/** Tell the reader about a finished reply while Jabberr is in a background tab. */
export function notifyBackground(title: string, body: string): void {
  if (!document.hidden) return;
  if (!('Notification' in window)) return;
  const show = (): void => {
    try {
      const n = new Notification(title, { body, tag: 'jabberr-reply' });
      n.onclick = () => {
        window.focus();
        n.close();
      };
    } catch {
      // Some browsers construct notifications only in secure workers; the title count still works.
    }
  };
  if (Notification.permission === 'granted') show();
  else if (Notification.permission === 'default') void Notification.requestPermission().then((p) => (p === 'granted' ? show() : undefined));
}

/** Tell the reader about a fresh @mention (until it is read) while Jabberr is not in view. */
export function notifyMention(title: string, body: string): void {
  if (!('Notification' in window)) return;
  const show = (): void => {
    try {
      const n = new Notification(title, { body, tag: 'jabberr-mention' });
      n.onclick = () => {
        window.focus();
        n.close();
      };
    } catch {
      // Same secure-context caveat as notifyBackground; the banner and badge still work.
    }
  };
  if (Notification.permission === 'granted') show();
  else if (Notification.permission === 'default') void Notification.requestPermission().then((p) => (p === 'granted' ? show() : undefined));
}
